import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
`;

const ShimmerEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.05), transparent);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
`;

const StyledImage = styled.img<{ $loaded: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

interface ImageWithLoaderProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({ src, alt, style, onClick }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <ImageWrapper style={style} onClick={onClick}>
      {!loaded && <ShimmerEffect />}
      <StyledImage
        src={src}
        alt={alt}
        $loaded={loaded}
        onLoad={() => setLoaded(true)}
        loading="lazy"
      />
    </ImageWrapper>
  );
};
